"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=vogelAcademyWorkshops.js.map